module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_tablet_08@2x-a2ca4f5e2c71fb4d1c4e456d2aeb944e.jpg";